import { ColorPalette } from '@atlaskit/editor-common/ui-color';
export default ColorPalette;